export default "<button class=\"player__panel-button j-preview-btn\" title=\"Create Preview\">\n  <span class=\"icon-container\"></span>\n</button>\n"